module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGBACCARAT-0255b0b6f4258354fff601bca747ea34.png";